module.exports = __webpack_public_path__ + "img/ic-logout.6a5af588.svg";